/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* NWC, Nov 2026: links in the Buddha Mega Menu that point to a collection open with
   the in-stock filter on (?filter.v.availability=1). Archive of Sold Maps is left
   unfiltered. Visitors can clear the filter on the collection page. */
(function () {
  var PARAM = 'filter.v.availability=1';
  var SKIP = ['/collections/archive-of-sold-maps'];
  function fix(a) {
    if (!a || !a.closest || !a.closest('.buddha-menu-item, .mm-submenu')) return;
    ['data-href', 'href'].forEach(function (attr) {
      var v = a.getAttribute(attr);
      if (!v || v.indexOf('/collections/') !== 0 || v.indexOf('/products/') !== -1) return;
      if (v.indexOf('filter.v.availability') !== -1) return;
      var path = v.split('?')[0].split('#')[0];
      if (SKIP.indexOf(path) !== -1) return;
      a.setAttribute(attr, v + (v.indexOf('?') === -1 ? '?' : '&') + PARAM);
    });
  }
  function fixAll() {
    var links = document.querySelectorAll('.buddha-menu-item a, .mm-submenu a, .mm-submenu li[data-href]');
    for (var i = 0; i < links.length; i++) fix(links[i]);
  }
  ['mousedown', 'touchstart', 'keydown', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var el = e.target && e.target.closest ? e.target.closest('a, li[data-href]') : null;
      if (el) { fix(el); fix(el.parentElement && el.parentElement.closest('li[data-href]')); }
    }, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixAll); else fixAll();
  window.addEventListener('load', fixAll);
  var n = 0, t = setInterval(function () { fixAll(); if (++n > 10) clearInterval(t); }, 1000);
})();

/* NWC, Nov 2026: the creator links on product pages are built without URL encoding,
   so names containing "&" (e.g. Currier & Ives) open an empty results page.
   This re-encodes the creator name in those links. */
(function () {
  var KEY = 'filter.p.m.custom.creator=';
  function encodeCreatorLinks() {
    var links = document.querySelectorAll('a[href*="' + KEY + '"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], href = a.getAttribute('href');
      if (a.getAttribute('data-nwc-enc')) continue;
      var at = href.indexOf(KEY) + KEY.length;
      var name = href.slice(at);
      try { name = decodeURIComponent(name.replace(/\+/g, ' ')); } catch (e) {}
      a.setAttribute('href', href.slice(0, at) + encodeURIComponent(name.trim()));
      a.setAttribute('data-nwc-enc', '1');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', encodeCreatorLinks); else encodeCreatorLinks();
})();
